<template>
    <div>
        <!--&lt;!&ndash; 历史记录 &ndash;&gt;-->
        <!--<div class="history_records" v-for="(item,i) in detail.history">-->
            <!--<h4>{{ item.action}}</h4>-->
            <!--<p>处理意见:{{ item.comment }}</p>-->
            <!--<span>{{ item.createUser}}</span><span>{{ item.createTime}}</span>-->
        <!--</div>-->

            <ul>
                <li v-for='(item, index) of detail.history' :key='index'>
                    <dl>
                        <dt>
                            <img :src="imgUrl" alt="">
                        </dt>
                        <dd>
                            <p>{{item.action}}</p>

                           <p> {{item.create_user}}--[ 处理意见 ]:{{ item.comment }}</p>

                            <p>
                                <span>{{item.to_user}} </span>
                                &nbsp;&nbsp; {{item.create_time}}
                            </p>

                        </dd>
                    </dl>
                </li>
            </ul>
        </div>

</template>

<script>
    export default {
        props:{
            detail:Object
        },
        data() {
            return {
                imgUrl: require('../../../assets/user.png')
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    ul>li>dl {
        width: 100%;
        display: flex;
        border-bottom: 1px dashed #000;
    }
    ul>li>dl>dt {
        width: 60px;
        padding-top: 10px;
        text-align: center;
    }
</style>
